import type { DefaultCmsDataResponse, Image, File } from '../types';

export interface Category {
  slug: string;
  count: number;
  description: string;
  link: null;
  createdAt: Date;
  updatedAt: Date;
  publishedAt: Date;
  locale: string;
  parent: number;
  name: string;
}

export interface PostTag {
  createdAt: Date;
  updatedAt: Date;
  publishedAt: Date;
  locale: string;
  name: string;
  slug: string;
  count: number;
  link: null;
  description: string;
}

export interface Post {
  title: string;
  content: string;
  author: number;
  slug: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  summary: string;
  thumbnail_url: string;
  link?: string;
  external_link?: string;
  file: {
    data: DefaultCmsDataResponse<File>;
  };
  images: {
    data: DefaultCmsDataResponse<Image>[];
  };
  categories: {
    data: DefaultCmsDataResponse<Category>[];
  };
  tags: {
    data: DefaultCmsDataResponse<PostTag>[];
  };
  follow?: boolean;
  index?: boolean;
  canonical_url?: string;
}

const catIds =
  (process.env.NEXT_PUBLIC_CATEGORY_BLOG_IDS || '2,5,152,3,8')
    .split(',')
    .map((item) => Number(item)) || [];
const catSlugs =
  (
    process.env.NEXT_PUBLIC_CATEGORY_BLOG_SLUGS ||
    'khach-hang,tai-xe,ahamovers,doi-tac,dong-hanh-cung-thuong-hieu'
  ).split(',') || [];

export const DisplayCategory = {
  KHACH_HANG: catSlugs[0],
  TAI_XE: catSlugs[1],
  AHAMOVERS: catSlugs[2],
  DOI_TAC: catSlugs[3],
  DONG_HANH_CUNG_THUONG_HIEU: catSlugs[4],
} as const;

export type DisplayCategory =
  typeof DisplayCategory[keyof typeof DisplayCategory];

export enum DisplayCategoryBlog {
  THONG_TIN_DICH_VU = 'thong-tin-dich-vu',
  KIEN_THUC_GIAO_HANG = 'kien-thuc-giao-hang',
  KINH_NGHIEM_KINH_DOANH = 'kinh-nghiem-kinh-doanh',
  NGUON_HANG = 'nguon-hang',
}

export const displayCategories: Record<
  string,
  { id: number; slug: string; name: string }
> = {
  [DisplayCategory.KHACH_HANG]: {
    id: catIds[0],
    slug: DisplayCategory.KHACH_HANG,
    name: 'Khách hàng',
  },
  [DisplayCategory.TAI_XE]: {
    id: catIds[1],
    slug: DisplayCategory.TAI_XE,
    name: 'Tài xế',
  },
  [DisplayCategory.AHAMOVERS]: {
    id: catIds[2],
    slug: DisplayCategory.AHAMOVERS,
    name: 'Ahamovers',
  },
  [DisplayCategory.DOI_TAC]: {
    id: catIds[3],
    slug: DisplayCategory.DOI_TAC,
    name: 'Đối tác',
  },
  [DisplayCategory.DONG_HANH_CUNG_THUONG_HIEU]: {
    id: catIds[4],
    slug: DisplayCategory.DONG_HANH_CUNG_THUONG_HIEU,
    name: 'Đồng hành cùng Thương hiệu',
  },
};

export const displayCategoriesBlog: Record<
  string,
  { id: number; slug: string; name: string }
> = {
  [DisplayCategoryBlog.THONG_TIN_DICH_VU]: {
    id: 9,
    slug: DisplayCategoryBlog.THONG_TIN_DICH_VU,
    name: 'Thông tin dịch vụ',
  },
  [DisplayCategoryBlog.KIEN_THUC_GIAO_HANG]: {
    id: 10,
    slug: DisplayCategoryBlog.KIEN_THUC_GIAO_HANG,
    name: 'Kiến thức giao hàng',
  },
  [DisplayCategoryBlog.KINH_NGHIEM_KINH_DOANH]: {
    id: 11,
    slug: DisplayCategoryBlog.KINH_NGHIEM_KINH_DOANH,
    name: 'Kinh nghiệm kinh doanh',
  },
  [DisplayCategoryBlog.NGUON_HANG]: {
    id: 12,
    slug: DisplayCategoryBlog.NGUON_HANG,
    name: 'Nguồn hàng',
  },
};
